export function stripHTML(unsafe: string) {
  return new DOMParser().parseFromString(unsafe, 'text/html').documentElement.textContent;
}
